var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.45 21.95C21.25 21.95 21.95 21.35 21.95 20.55V3.45005C21.95 2.65005 21.25 2.05005 20.45 2.05005H3.45005C2.75005 2.05005 2.05005 2.65005 2.05005 3.45005V20.55C2.05005 21.35 2.75005 21.95 3.55005 21.95H20.45ZM7.95005 19.05H5.05005V9.55005H8.05005V19.05H7.95005ZM9.85005 9.55005H12.65V10.85C13.05 10.05 14.05 9.25005 15.45 9.25005C18.45 9.25005 18.95 11.25 18.95 13.75V19.05H15.95V14.45C15.95 13.35 15.95 11.95 14.45 11.95C12.95 11.95 12.65 13.15 12.65 14.35V19.05H9.65005V9.55005H9.85005ZM6.45005 4.75005C7.35005 4.75005 8.15005 5.55005 8.15005 6.45005C8.15005 7.35005 7.35005 8.15005 6.45005 8.15005C5.55005 8.15005 4.75005 7.35005 4.75005 6.45005C4.75005 5.55005 5.55005 4.75005 6.45005 4.75005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.129571b4b0c32a7b99cb2b1fb27489c2.svg";
export { ForwardRef as ReactComponent };